import { HTTP } from '@/http-common'

function getBlock (blockId) {
  return HTTP.get('/blocks/' + blockId)
}

function addBlock (blockData) {
  let data = JSON.stringify(blockData)

  return HTTP.post('/blocks', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateBlock (blockData) {
  let data = JSON.stringify(blockData)

  return HTTP.put('/blocks/' + blockData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteBlock (blockId) {
  return HTTP.delete('/blocks/' + blockId)
}

function printBills (blockId, months, dateFrom, dateTo, months2, dateFrom2, dateTo2) {
  if (dateFrom2 && dateTo2) {
    return HTTP.get('/blocks/' + blockId + '/print-bills?months=' + months + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&months2=' + months2 + '&date_from2=' + dateFrom2 + '&date_to2=' + dateTo2, {responseType: 'arraybuffer'})
  } else {
    return HTTP.get('/blocks/' + blockId + '/print-bills?months=' + months + '&date_from=' + dateFrom + '&date_to=' + dateTo, {responseType: 'arraybuffer'})
  }
}

function applyRatePlan (blockId, ratePlanId) {
  return HTTP.get('/blocks/' + blockId + '/apply-rate-plan?rate_plan=' + ratePlanId)
}

function applyBilling (blockId, billDateTime) {
  return HTTP.get('/blocks/' + blockId + '/apply-billing?bill_datetime=' + billDateTime)
}

export { getBlock, addBlock, updateBlock, deleteBlock, printBills, applyRatePlan, applyBilling }



// WEBPACK FOOTER //
// ./src/services/block.service.js